"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateDoiPage = exports.UpdateDoiPageActionTypes = exports.updateDoiPage = exports.loadDoiPages = exports.FetchDoiPages = exports.FetchDoiPagesActionTypes = exports.fetchDoiPages = exports.DoiPagesActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var DoiPagesActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_DOI_PAGES: null,
  LOAD_DOI_PAGES: null,
  UPDATE_DOI_PAGE: null
}, _constants.DOI_PAGES);
exports.DoiPagesActionTypes = DoiPagesActionTypes;
var fetchDoiPages = (0, _fluxActions.createAction)(DoiPagesActionTypes.LOAD_DOI_PAGES);
exports.fetchDoiPages = fetchDoiPages;
var FetchDoiPagesActionTypes = (0, _actions.createRequestTypes)(DoiPagesActionTypes.FETCH_DOI_PAGES);
exports.FetchDoiPagesActionTypes = FetchDoiPagesActionTypes;
var FetchDoiPages = (0, _actions.createRequestActions)(FetchDoiPagesActionTypes);
exports.FetchDoiPages = FetchDoiPages;
var loadDoiPages = (0, _fluxActions.createAction)(DoiPagesActionTypes.LOAD_DOI_PAGES);
exports.loadDoiPages = loadDoiPages;
var updateDoiPage = (0, _fluxActions.createAction)(DoiPagesActionTypes.UPDATE_DOI_PAGE, (0, _actions.mapPayloadTo)('data'));
exports.updateDoiPage = updateDoiPage;
var UpdateDoiPageActionTypes = (0, _actions.createRequestTypes)(DoiPagesActionTypes.UPDATE_DOI_PAGE);
exports.UpdateDoiPageActionTypes = UpdateDoiPageActionTypes;
var UpdateDoiPage = (0, _actions.createRequestActions)(UpdateDoiPageActionTypes);
exports.UpdateDoiPage = UpdateDoiPage;